import { SVGProps } from "react";

export const ListBullets2Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg fill="none" viewBox="0 0 24 24" width={size} height={size} {...rest}>
      <path
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M8.5 4.5h15m-15 8h15m-15 8h15M4.5 2.5h-4v4h4v-4Zm0 8h-4v4h4v-4Zm0 8h-4v4h4v-4Z"
      />
    </svg>
  );

  return render();
};
